/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable no-use-before-define, max-len */
import Axios, {
  AxiosInstance,
  AxiosResponse,
} from 'axios';
import { Client } from 'src/hooks/query/clients/types';
import { JobTitle } from 'src/hooks/query/job-titles/types';
import { UserByRole, UserByRoleRequest } from 'src/hooks/query/usersByRole/types';
import { ConsultancyResponse } from 'src/hooks/query/consultancies/types';
import { GetVendorsRequest, Vendor } from 'src/pages/ViewJob/types';
import { consultancy } from './configuration';

// import {
// } from './configuration';

/**
 * Requests
 */
class Requests {
  static client: Requests;

  axios: AxiosInstance;

  constructor() {
    this.axios = Axios.create({
      baseURL: process.env.REACT_APP_AUTH_SERVICES_API,
    });
    this.axios.defaults.withCredentials = process.env.REACT_APP_AUTH_CROSS_ORIGIN_REQUESTS_ENABLED === 'true';
    this.axios.defaults.timeout = 35000;
  }

  setBearerToken = (token: string) => {
    this.axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  };

  static getInstance = () => {
    if (!Requests.client) {
      Requests.client = new Requests();
    }
    return Requests.client;
  };

  getClients = () => this.axios.get<Client[]>('/clients');

  getJobtitles = () => this.axios.get<JobTitle[]>('/designation');

  getUsersByRoles = (payload: UserByRoleRequest) => this.axios.post<UserByRole[]>('/user/roleInterviewer', payload);

  getConsultancyOptions = (data: GetVendorsRequest) => this.axios.post(consultancy.getConsultancyOptions, data).then(
    (response: AxiosResponse<ConsultancyResponse>) => response.data,
  );

  getConsultancyById = (id: string) => this.axios.get<Vendor>(consultancy.getConsultancyById + id);
}

export default Requests;
